import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cgu',
  templateUrl: './cgu.component.html',
  styleUrls: ['./cgu.component.scss'],
})
export class CguComponent  implements OnInit {

  email : string = "Coachcompanion95@gmail.com";

  constructor(private readonly router : Router) { }

  ngOnInit() {}

  backClick() {
    this.router.navigateByUrl("/coach/about");
  }

}
